import { render } from "./connect-client-activity.vue?vue&type=template&id=14d829e1&scoped=true"
import script from "./connect-client-activity.vue?vue&type=script&lang=js"
export * from "./connect-client-activity.vue?vue&type=script&lang=js"

import "./connect-client-activity.vue?vue&type=style&index=0&id=14d829e1&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d829e1"]])

export default __exports__